import Dispatcher from "./models/dispatcher/index.js";
import Resolver from "./models/resolver.js";
/**
 * Contains the settings for the MediatR lib
 *
 * @class MediatrSettings
 */
var MediatrSettings = /** @class */ (function () {
    function MediatrSettings() {
        this.resolver = new Resolver();
        this.dispatcher = new Dispatcher();
    }
    return MediatrSettings;
}());
var mediatorSettings = new MediatrSettings();
export default mediatorSettings;
//# sourceMappingURL=settings.js.map